import { Icon } from "@iconify/react";
import eyeFill from "@iconify/icons-eva/eye-fill";
import { Link as RouterLink } from "react-router-dom";
import shareFill from "@iconify/icons-eva/share-fill";
import messageCircleFill from "@iconify/icons-eva/message-circle-fill";
// material
import {
  Box,
  Grid,
  Link,
  Card,
  Avatar,
  Typography,
  CardContent,
} from "@mui/material";
import { styled } from "@mui/material/styles";
// routes
// utils
import { fDate } from "../../utils/formatTime";
import { fShortenNumber } from "../../utils/formatNumber";
// @types
import { Post } from "../../types/blog";
//
import SvgIconStyle from "../SvgIconStyle";

// ----------------------------------------------------------------------

const CoverImgStyle = styled("img")(({ theme }) => ({
  top: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  position: "absolute",
  padding: "10px",
}));

// ----------------------------------------------------------------------

type PostItemProps = {
  post: Post;
};

function PostItem({ post }: PostItemProps) {
  const { cover, title, view, comment, share, author, createdAt } = post;
  const linkTo = `/blog/post/${post.id}`;

  const POST_INFO = [
    { number: comment, icon: messageCircleFill },
    { number: view, icon: eyeFill },
    { number: share, icon: shareFill },
  ];

  return (
    <Grid>
      <Card>
        <Box sx={{ position: "relative", paddingTop: "calc(100% * 3 / 4)" }}>
          <SvgIconStyle
            color="paper"
            src="/static/icons/shape-avatar.svg"
            sx={{
              width: 80,
              height: 36,
              zIndex: 9,
              bottom: -15,
              position: "absolute",
            }}
          />
          <Avatar
            alt={author.name}
            // src={author.avatarUrl}
            src="https://firebasestorage.googleapis.com/v0/b/refrigeration-9e407.firebasestorage.app/o/avatar%2Favatar.webp?alt=media&token=ee0c08d9-8d64-4937-9e2d-6203c00c1c58"
            sx={{
              left: 24,
              zIndex: 9,
              width: 32,
              height: 32,
              bottom: -16,
              position: "absolute",
            }}
          />
          <CoverImgStyle alt="cover" src={cover} />
        </Box>

        <CardContent sx={{ pt: 4.5 }}>
          <Typography
            gutterBottom
            variant="caption"
            sx={{ color: "text.disabled", display: "block" }}
          >
            {fDate(createdAt)}
          </Typography>

          <Link
            to={linkTo}
            color="inherit"
            variant="subtitle2"
            component={RouterLink}
            sx={{
              height: 44,
              overflow: "hidden",
              WebkitLineClamp: 2,
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
            }}
          >
            {title}
          </Link>

          {/* <Box
            sx={{
              mt: 3,
              display: "flex",
              flexWrap: "wrap",
              color: "text.disabled",
              justifyContent: "flex-end",
            }}
          >
            {POST_INFO.map((info, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  ml: index === 0 ? 0 : 1.5,
                }}
              >
                <Box
                  component={Icon}
                  icon={info.icon}
                  sx={{ width: 16, height: 16, mr: 0.5 }}
                />
                <Typography variant="caption">
                  {fShortenNumber(info.number)}
                </Typography>
              </Box>
            ))}
          </Box> */}
        </CardContent>
      </Card>
    </Grid>
  );
}

type BlogPostRecentProps = {
  posts: Post[];
};

export default function BlogPostRecent({ posts }: BlogPostRecentProps) {
  return (
    <>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Recent posts
      </Typography>

      <Grid container spacing={3} className="justify-center pb-10">
        {posts.map((post) => (
          <PostItem key={post.id} post={post} />
        ))}
      </Grid>
    </>
  );
}
